module.exports = __webpack_public_path__ + "resources/img/main01_m.5ac8a6707a2ca0679d12951ff83b6777.png";